// src/hooks/useDataBackground.ts
import { useEffect } from "react";

export function useDataBackground(attr: string = "data-background") {
  useEffect(() => {
    if (typeof window === "undefined") return;
    const nodes = document.querySelectorAll<HTMLElement>(`[${attr}]`);
    nodes.forEach((el) => {
      const url = el.getAttribute(attr);
      if (url) el.style.backgroundImage = `url(${url})`;
    });
  }, [attr]);
}
